import { WireNameValue } from './nameValue.types';

export enum WireAustralianStates {
  NSW = 'NSW',
  VIC = 'VIC',
  WA = 'WA',
  NT = 'NT',
  TAS = 'TAS',
  QLD = 'QLD',
  SA = 'SA',
  ACT = 'ACT',
}

type AustralianState =
  | 'NSW'
  | 'VIC'
  | 'WA'
  | 'NT'
  | 'TAS'
  | 'QLD'
  | 'SA'
  | 'ACT';

export type WireAddress = {
  id: string;
  unitNumber: string;
  streetNumber: string;
  streetName: string;
  fullName?: string;
  suburb: string;
  state: AustralianState;
  postcode: string;
  gnaf: string;
  geocode?: string;
  reliability?: string;
  longitude: string;
  latitude: string;
  isPOBox?: boolean;
  otherAttributes?: WireNameValue[];
};
